import React, { useRef } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import {
  Button,
  CardActionArea,
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Stack,
  useMediaQuery,
  IconButton
} from "@mui/material";
import { ReactComponent as ShareNewsIcon } from "../Icons/shareNewsIcon.svg";
import { ReactComponent as FavouritesNewsIcon } from "../Icons/favouritesNewsIcon.svg";
import parse from "html-react-parser";
import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { ReactComponent as LeftArrowIcon } from "../Icons/leftArrow.svg";
import { ReactComponent as RightArrowIcon } from "../Icons/rightArrow.svg";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

const NewsCarousel = ({ NewsData }) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:600px)');
  const isTablet = useMediaQuery('(min-width:600px) and (max-width:960px)');
  const isBetween1024And1280 = useMediaQuery('(min-width:1024px) and (max-width:1279px)');
  const carouselRef = useRef(null);
  const language = useSelector((state) => state.language.language)
  const styless = useSelector((state) => state.styles)
  const { t } = useTranslation()

  console.log(NewsData)

  const truncateDescription = (description, char) => {
    if (typeof description !== "string") return "";
  
    const truncated = description.slice(0, char);
  
    return description.length > 69 ? truncated + "..." : truncated;
  };


  const styles = {
    controlDots: {
      margin: "138px 0px !important",
    },
    selectedDot: {
      width: "36px",
      height: "8px",
      borderRadius: "24px",
      background: "#434343",
      margin: "0 4px",
    },
    UnselectedDot: {
      width: "8px",
      height: "8px",
      borderRadius: "24px",
      background: "#FFFFFF",
      border: "1px solid #434343",
      margin: "0 4px",
    },
  };

  const handlePrev = () => {
    if (carouselRef.current) {
      carouselRef.current.decrement();
    }
  };

  const handleNext = () => {
    if (carouselRef.current) {
      carouselRef.current.increment();
    }
  };

  const handleShare = (id) => {
    const url = `${window.location.origin}/news/${id}`;
  
    if (navigator.share) {
      navigator.share({
        title: "Check this out!",
        text: "Interesting News",
        url,
      }).catch((err) => {
        console.error("Sharing failed", err);
      });
    } else {
      navigator.clipboard.writeText(url).then(() => {
        // toast.success("Link copied to clipboard!");
      }).catch((err) => {
        console.error("Clipboard error", err);
      });
    }
  };

  return (
      <>
    <Box sx={{mb: {xs : 2, lg : 5}, flexDirection : {xs : 'column', md : 'row'},mx : {xs : "10px", sm : "60px"}, gap : {xs : '10px', sm : '30px'}, display : 'flex', justifyContent : 'space-between', alignItems : 'center'}} >
          <Box></Box>
          <Typography
            p={2}
            variant="h6_1"
            color="primary"
            border="1px solid #27BAC4"
            padding="10px 50px"
            borderRadius="50px"
            letterSpacing="1.1px"
            sx={{...styless.h2}}
          >
            {t("NEWS")}
          </Typography>
          <Stack
            // columnGap="20px"
            direction="row"
            justifyContent="space-between"
            sx={{gap : {xs : '10px', lg : '20px'}}}
          >
            <Box
              sx={{
                width: "40px",
                height: "40px",
                borderRadius: "100px",
                backgroundColor: "#2DB7C2",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={handlePrev}
            >
              <LeftArrowIcon />
            </Box>
            <Box
              sx={{
                width: "40px",
                height: "40px",
                borderRadius: "100px",
                backgroundColor: "#2DB7C2",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={handleNext}
            >
              <RightArrowIcon />
            </Box>
          </Stack>
        </Box>
       
     
    
    <Box className="Newscaurosel" sx={{mt : '40px', pt : '40px', background: "#EFF4FC", display: 'flex', justifyContent: 'center', overflow : 'hidden', pr : {xs : 0, lg : 0}}}>
      <Carousel
        id="news"
        ref={carouselRef}
        showArrows={true}
        showThumbs={false}
        showStatus={false}
        useKeyboardArrows
        centerMode={!isMobile}
        centerSlidePercentage={isMobile ? 100 : isTablet ? 100 : isBetween1024And1280 ? 49 : 37}
        emulateTouch
        renderIndicator={(onClickHandler, isSelected, index, label) => {
          const indicatorStyle = isSelected
            ? styles.selectedDot
            : styles.UnselectedDot;
          return (
            <li
              style={{
                ...indicatorStyle,
                display: "inline-block",
                cursor: "pointer",
                marginTop : 20,
                marginBottom : -16,
              }}
              onClick={onClickHandler}
              onKeyDown={onClickHandler}
              value={index}
              key={index}
              role="button"
              tabIndex={0}
              aria-label={`${label} ${index + 1}`}
            />
          );
        }}
      >
        {NewsData?.map((itm, index) => (
          <Card
            key={index}
            sx={{
              
              maxWidth: isMobile ? 300 : isTablet ? 520 : isBetween1024And1280 ? 350 : 400,
              maxHeight : '100%',
              p: 1.5,
              boxShadow : '0px 4px 20px 0px rgba(0, 0, 0, 0.15)',
              //border: ".5px solid #737373",
              borderRadius: "20px",
              textAlign: "start",
              position: "relative",
              margin: 'auto',
              // margin: isMobile ? 'auto auto' : isTablet ? '0px 30px' : '0 10px',
              // margin : {xs : 'auto auto', md : 'auto', lg : 'auto'},
              height : {xs : '380px', sm : '510px',lg : 'auto'},
            }}
          >
            <Stack
              direction="row"
              columnGap="10px"
              sx={{
                position: "absolute",
                zIndex: "1",
                right: "25px",
                top: "25px",
              }}
            >
              <ShareNewsIcon sx={{":hover" : {cursor : 'pointer'}}} onClick={() => handleShare(itm?._id)}/>
              {/* <FavouritesNewsIcon /> */}
            </Stack>
            <CardActionArea sx={{position : 'relative', height : '100%'}}>
              <CardMedia
                sx={{ borderRadius: "20px", height: {xs : '193px', sm : '320px', lg : '240px'}, width :'402px' }}
                component="img"
                image={process.env.REACT_APP_FILE_PATH + itm?.img}
                alt="news image"

              />
              {/* <Box sx={{border : '2px solid red', objectFit : 'cover', height : '240px'}} component={"img"} src={process.env.REACT_APP_FILE_PATH + itm?.img}></Box> */}
              <CardContent sx={{mb : 6}}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{height : {xs : '45px', lg : '65px'}}}
                >
                  <Typography
                    gutterBottom
                    variant="h7_1"
                    component="div"
                    color="#007ECA"
                  >
                    {Boolean(itm?.description)
                    ? parse(truncateDescription(itm?.title?.[language], 60))
                    : ""}
                    {/* {itm?.title?.[language]} */}
                  </Typography>
                  {/* <Typography
                    variant="h9_4"
                    color="#007ECA"
                    sx={{
                      width: "42px",
                      height: "24px",
                      border: ".5px solid #007ECA",
                      padding: "0 10px 26px 10px",
                      borderRadius: "80px",
                    }}
                  >
                    tag
                  </Typography> */}
                </Stack>
                <Typography variant="h9_4">
                  {Boolean(itm?.description)
                    ? parse(truncateDescription(itm?.description?.[language], 50))
                    : ""}
                </Typography>
              </CardContent>

              <Stack sx={{ position : 'absolute', bottom : 0, right : 0}} direction="row" justifyContent="end" alignItems='end'>
              <Button
                onClick={() => navigate(`/news/${itm?._id}`)}
                variant="contained"
                sx={{
                  width: "100px",
                  height: "40px",
                  padding: "10px 24px",
                  backgroundColor: "#007eca",
                  borderRadius: "80px",
                  color: "white",
                  textTransform: "none",
                  letterSpacing: "1px",
                  fontWeight: 700,
                  fontSize: "16",
                  ...styless.button
                }}
              >
                {t("More")}
              </Button>
            </Stack>
            </CardActionArea>
            
          </Card>
        ))}
      </Carousel>
    </Box>
    </>
  );
};

export default NewsCarousel;



// import React, { useRef } from 'react';
// import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
// import { Carousel } from 'react-responsive-carousel';
// import {
//   Button,
//   CardActionArea,
//   Box,
//   Card,
//   CardContent,
//   CardMedia,
//   Typography,
//   Stack,
//   useMediaQuery,
//   IconButton
// } from "@mui/material";
// import { ReactComponent as ShareNewsIcon } from "../Icons/shareNewsIcon.svg";
// import { ReactComponent as FavouritesNewsIcon } from "../Icons/favouritesNewsIcon.svg";
// import parse from "html-react-parser";
// import { useNavigate } from "react-router-dom";
// import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
// import { ReactComponent as LeftArrowIcon } from "../Icons/leftArrow.svg";
// import { ReactComponent as RightArrowIcon } from "../Icons/rightArrow.svg";
// import { useSelector } from 'react-redux';

// const NewsCarousel = ({ NewsData }) => {
//   const navigate = useNavigate();
//   const isMobile = useMediaQuery('(max-width:600px)');
//   const isTablet = useMediaQuery('(min-width:600px) and (max-width:960px)');
//   const carouselRef = useRef(null);
//   const language = useSelector((state) => state.language.language)

//   console.log(NewsData)

//   const truncateDescription = (description) => {
//     if (typeof description !== "string") return "";
//     const words = description.split(" ");
    
    
//     if (words.length > 15 && words.length < Infinity ) {
    
//       return words.slice(0, 9).join(" ") + "...";
//     }else if(words.length < 15){
//       return words.slice(0, 5).join(' ') + "...";
//     }
//     return description;
//   };

//   const styles = {
//     controlDots: {
//       margin: "138px 0px !important",
//     },
//     selectedDot: {
//       width: "36px",
//       height: "8px",
//       borderRadius: "24px",
//       background: "#434343",
//       margin: "0 4px",
//     },
//     UnselectedDot: {
//       width: "8px",
//       height: "8px",
//       borderRadius: "24px",
//       background: "#FFFFFF",
//       border: "1px solid #434343",
//       margin: "0 4px",
//     },
//   };

//   const handlePrev = () => {
//     if (carouselRef.current) {
//       carouselRef.current.decrement();
//     }
//   };

//   const handleNext = () => {
//     if (carouselRef.current) {
//       carouselRef.current.increment();
//     }
//   };

//   return (
//       <>
//     <Stack px={5} mb={5} direction="row" justifyContent="space-between">
//           <Box></Box>
//           <Typography
//             p={2}
//             variant="h6_1"
//             color="primary"
//             border="1px solid #27BAC4"
//             padding="10px 50px"
//             borderRadius="50px"
//             letterSpacing="1.1px"
//           >
//             NEWS
//           </Typography>
//           <Stack
//             columnGap="20px"
//             direction="row"
//             justifyContent="space-between"
//           >
//             <Box
//               sx={{
//                 width: "40px",
//                 height: "40px",
//                 borderRadius: "100px",
//                 backgroundColor: "#2DB7C2",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//               onClick={handlePrev}
//             >
//               <LeftArrowIcon />
//             </Box>
//             <Box
//               sx={{
//                 width: "40px",
//                 height: "40px",
//                 borderRadius: "100px",
//                 backgroundColor: "#2DB7C2",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//               onClick={handleNext}
//             >
//               <RightArrowIcon />
//             </Box>
//           </Stack>
//         </Stack>
       
     
    
//     <Box mt={5} className="Newscaurosel" sx={{ pt: 7,pb: 3,background: "#EFF4FC", display: 'flex', justifyContent: 'center', overflow : 'hidden', pr : {xs : 3, lg : 0}}}>
//       <Carousel
//         id="news"
//         ref={carouselRef}
//         showArrows={true}
//         showThumbs={false}
//         showStatus={false}
//         useKeyboardArrows
//         centerMode={!isMobile}
//         centerSlidePercentage={isMobile ? 100 : isTablet ? 100 : 33.33}
//         emulateTouch
//         renderIndicator={(onClickHandler, isSelected, index, label) => {
//           const indicatorStyle = isSelected
//             ? styles.selectedDot
//             : styles.UnselectedDot;
//           return (
//             <li
//               style={{
//                 ...indicatorStyle,
//                 display: "inline-block",
//                 cursor: "pointer",
//                 marginTop : 20,
//                 marginBottom : -16,
//               }}
//               onClick={onClickHandler}
//               onKeyDown={onClickHandler}
//               value={index}
//               key={index}
//               role="button"
//               tabIndex={0}
//               aria-label={`${label} ${index + 1}`}
//             />
//           );
//         }}
//       >
//         {NewsData?.map((itm, index) => (
//           <Card
//             key={index}
//             sx={{
              
//               maxWidth: isMobile ? 350 : isTablet ? 680 :390,
//               maxHeight : '100%',
//               p: 1.5,
//               boxShadow : '0px 4px 20px 0px rgba(0, 0, 0, 0.15)',
//               //border: ".5px solid #737373",
//               borderRadius: "20px",
//               textAlign: "start",
//               position: "relative",
//               margin: isMobile ? 'auto auto' : isTablet ? '0px 30px' : '0 10px',
//               height : {xs : '380px', sm : '510px',lg : '410px'}
//             }}
//           >
//             <Stack
//               direction="row"
//               columnGap="10px"
//               sx={{
//                 position: "absolute",
//                 zIndex: "1",
//                 right: "25px",
//                 top: "25px",
//               }}
//             >
//               <ShareNewsIcon />
//               <FavouritesNewsIcon />
//             </Stack>
//             <CardActionArea>
//               <CardMedia
//                 sx={{ borderRadius: "20px", height: {xs : '193px', sm : '320px', lg : '193px'}, width :'402px' }}
//                 component="img"
//                 image={process.env.REACT_APP_FILE_PATH + itm?.img}
//                 alt="news image"
//               />
//               <CardContent>
//                 <Stack
//                   direction="row"
//                   justifyContent="space-between"
//                   alignItems="center"
//                   sx={{height : {xs : '45px', lg : '65px'}}}
//                 >
//                   <Typography
//                     gutterBottom
//                     variant="h7_1"
//                     component="div"
//                     color="#007ECA"
//                   >
//                     {itm?.title?.[language]}
//                   </Typography>
//                   <Typography
//                     variant="h9_4"
//                     color="#007ECA"
//                     sx={{
//                       width: "42px",
//                       height: "24px",
//                       border: ".5px solid #007ECA",
//                       padding: "0 10px 26px 10px",
//                       borderRadius: "80px",
//                     }}
//                   >
//                     tag
//                   </Typography>
//                 </Stack>
//                 <Typography variant="h9_4">
//                   {Boolean(itm?.description)
//                     ? parse(truncateDescription(itm?.description?.[language]))
//                     : ""}
//                 </Typography>
//               </CardContent>
//             </CardActionArea>
//             <Stack direction="row" justifyContent="end" alignItems='end'>
//               <Button
//                 onClick={() => navigate(`/news/${itm?._id}`)}
//                 variant="contained"
//                 sx={{
//                   width: "80px",
//                   height: "40px",
//                   padding: "10px 30px",
//                   backgroundColor: "#007eca",
//                   borderRadius: "80px",
//                   color: "white",
//                   textTransform: "none",
//                   letterSpacing: "1px",
//                   fontWeight: 700,
//                   fontSize: "16",
//                 }}
//               >
//                 More
//               </Button>
//             </Stack>
//           </Card>
//         ))}
//       </Carousel>
//     </Box>
//     </>
//   );
// };

// export default NewsCarousel;
